import styled from 'styled-components';
import GDBREAKPOINTS from '../themes/breakpoints';

const { MD_MIN } = GDBREAKPOINTS;

export const MatchupWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    width: 100%;
    margin: 0 auto;
    background-color: var(--gameday-background-color);

    @media (min-width: ${MD_MIN}) {
        padding: var(--gameday-section-padding-sm);
    }
`;

export const MainGameInfoWrapper = styled.div`
    display: flex;
`;
